module.exports = __webpack_public_path__ + "static/media/blog-img3.e7102151.png";